import { CREATE_CHAUFFEUR, CREATE_CHAUFFEUR_SUCCESS, CREATE_CHAUFFEUR_ERROR, CREATE_CHAUFFEUR_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateChauffeur = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHAUFFEUR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CHAUFFEUR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_CHAUFFEUR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CHAUFFEUR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateChauffeur;
